var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"card"},[_c('div',{staticClass:"card-header"},[_c('h4',{staticClass:"card-header-title"},[_vm._v(_vm._s(_vm.$t('components.partners.partnersDeposits')))]),_c('router-link',{staticClass:"btn btn-sm btn-primary",attrs:{"to":'/partnersDeposits/create?partner_id=' + _vm.$route.params.id}},[_c('i',{staticClass:"fas fa-plus"}),_vm._v(" "+_vm._s(_vm.$t('components.partners.addition'))+" ")])],1),_c('indexTable',{attrs:{"searchText":_vm.$t('partnersDeposits.SearchForAnOperation'),"emptyTableText":_vm.$t('partnersDeposits.NoDeposits'),"filter":{partner_id: _vm.$route.params.id},"withoutCard":true,"emptyTableSubText":_vm.$t('allerts.TryAddingSomeItemsToTheTableAndTryAgain'),"cloumns":[
        {
          column: 'code',
          title: _vm.$t('partnersDeposits.Process'),
          type: 'mainLink',
          sort: true,
        },
        {
          column: 'partner_id',
          title: _vm.$t('partnersDeposits.PartnerName'),
          type: 'link',
          to: 'partner',
          sort: true,
          link: true,
        },
        {
          column: 'safe_id',
          title: _vm.$t('partnersDeposits.Treasury'),
          type: 'link',
          to: 'safe',
          sort: true,
          link: true,
        },
        {
          column: 'date',
          title: _vm.$t('partnersDeposits.date'),
          type: 'text',
          sort: true,
        },
        {
          column: 'description',
          title: _vm.$t('partnersDeposits.AndThatIsAbout'),
          type: 'text',
          sort: true,
        },
        {
          column: 'cost',
          title: _vm.$t('partnersDeposits.cost'),
          type: 'text',
          sort: true,
        },
        {
          column: 'options',
          title: _vm.$t('partnersDeposits.actions'),
          type: 'options',
          options: [
            { name: 'show' },
            {
              name: 'edit',
              role:
                _vm.$user.admin ||
                _vm.$user.role.sales_payments_edit,
            },
            { name: 'printSalesPayment', role: true },
            { name: 'download', role: true },
            {
              name: 'delete',
              role:
                _vm.$user.admin ||
                _vm.$user.role.sales_payments_delete,
            } ],
        } ],"deleteText":{
        attention: _vm.$t('allerts.Attention'),
        areYouReallySureToDeleteTheItem: _vm.$t(
          'allerts.areYouReallySureToDeleteTheItem'
        ),
        close: _vm.$t('allerts.close'),
        confirm: _vm.$t('allerts.confirm'),
        loading: _vm.$t('allerts.loading'),
      }}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }